import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import textBaseStyle from '../../../../components/Text/text-base.module.css';
import sectionStyle from '../../../../layout/Section/section.module.css';

interface Props {
  className?: string;
}

const ErrorMessage = ({
  children,
  className,
}: PropsWithChildren<Props>) => {
  // This usually renders unsafe HTML, and it is typically in a div.
  // Rendering a div here so we do not render a div inside a paragraph.
  return (
    <div
      className={classNames(
        sectionStyle.sectionErrorMessage,
        textBaseStyle.fontSize15,
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ErrorMessage;
